var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdCardFilled = function SvgIdCardFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 18h17v1a5 5 0 0 1-5 5H5a3 3 0 1 1 0-6m0-2h1V.1A5 5 0 0 0 2 5v12.025a4.96 4.96 0 0 1 2.395-.964A3 3 0 0 1 5 16M22 5v11H8V0h9a5 5 0 0 1 5 5m-9.077.5c0 1.379 1.121 2.5 2.5 2.5s2.5-1.121 2.5-2.5-1.121-2.5-2.5-2.5a2.5 2.5 0 0 0-2.5 2.5m6.933 5.982A5.2 5.2 0 0 0 15.423 9a5.2 5.2 0 0 0-4.433 2.482 1.001 1.001 0 0 0 1.711 1.037c.559-.922 1.627-1.518 2.722-1.518s2.163.596 2.722 1.518a1 1 0 1 0 1.711-1.037"
  })));
};
export default SvgIdCardFilled;